import { ApolloError, useMutation } from "@apollo/client";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import {
  CreateIndustryMutation as CreateIndustryMutationType,
  CreateIndustryMutationVariables,
} from "./__generated__/CreateIndustryMutation";

const CreateIndustryMutation = loader("./CreateIndustryMutation.gql");

type CreateIndustryMutationProviderType = (props: {
  children: (loading: boolean, mutate: any) => ReactNode;
  onError: (error: ApolloError) => void;
  onCompleted: (data: CreateIndustryMutationType) => void;
}) => ReactElement;

export const CreateIndustryMutationProvider: CreateIndustryMutationProviderType = (props) => {
  const { children, onError, onCompleted } = props;

  const [mutate, { loading }] = useMutation<CreateIndustryMutationType, CreateIndustryMutationVariables>(
    CreateIndustryMutation,
    {
      errorPolicy: "none",
      onError,
      onCompleted,
    },
  );

  return <Fragment>{children(loading, mutate)}</Fragment>;
};
